import React from 'react'
import Slider from 'react-slick'
import { Link } from 'react-router-dom'

class MainSlider extends React.Component {
  render() {
    var settings = {
      dots: true,
      arrows: false,
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: false,
      cssEase: 'linear',
      autoplay: true,
      autoplaySpeed: 5000
    };
    return (
      <Slider className="main-slider" {...settings}>
        <div>
          <div style={{ height: 'calc(100vw * 0.6666)' }}><video style={{width: '100%'}} src="/assets/home-placeholder-motion.mp4" loop="true" autoPlay="true" muted playsInline /></div>
          <Link to="/radiothon">
          <div className="subtext"><h3>RADIOTHON</h3>Keep Brisbane Weird - August 17-26</div>
          </Link>
        </div>
        <div className="slide-container">
          <div style={{ height: 'calc(100vw * 0.6666)', backgroundImage: 'url("/assets/4zzz-1021-boat.jpg")', backgroundSize: 'cover' }}>
          </div>
          <Link to="/programs">
          <div className="subtext"><h3>RADIO 4ZZZ</h3>102.1 on FM and ZedDigital on DAB in Brisbane, and streaming to the world.</div>
          </Link>
        </div>
        <div className="slide-container">
          <div style={{ height: 'calc(100vw * 0.6666)', backgroundImage: 'url("/assets/music-library.jpg")', backgroundSize: 'cover' }}>
          </div>
          <Link to="/music-submissions">
            <div className="subtext"><h3>Music Submissions</h3>Submit your tracks to the 4ZZZ Music Department for airplay.</div>
          </Link>
        </div>

        {/* <div>
          <div className="video-embed">
            <iframe width="560" height="315" src="https//www.youtube.com/embed/6rH853tp7Ig?rel=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
          </div>
          <div className="subtext"><h3>Right Here, Right Now: JO.L</h3>JO.L is an indie folk singer/songwriter from Brisbane's bay-side 'burbs and will be bringing the mmbop to Right Here, Right Now after 6pm tonight, live across 102.1FM and YouTube.</div>
        </div>  */}
        <div>
          <div style={{ height: 'calc(100vw * 0.6666)' }}><video style={{width: '100%'}} src="/assets/merchvid.mp4" loop="true" autoPlay="true" muted playsInline /></div>
          <Link to="/merch">
          <div className="subtext"><h3>MERCH</h3>Get your 4ZZZ merch on! Heaps of new stuff in stock!</div>
          </Link>
        </div>
        <div>
          <div style={{ height: 'calc(100vw * 0.6666)' }}><video style={{width: '100%'}} src="/assets/subvid.mp4" loop="true" autoPlay="true" muted playsInline /></div>
          <Link to="/subscribe">
          <div className="subtext"><h3>SUBSCRIBE</h3>Subscribe and support the station that connects and amplifies the voices of our community!</div>
          </Link>
        </div>

      </Slider>
    );
  }
}

export default MainSlider
